"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieParser = void 0;
var set_cookie_parser_1 = __importDefault(require("set-cookie-parser"));
var CookieParser = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function CookieParser(cookieName) {
        this.cookieName = cookieName;
    }
    /**
     * @param headerValue the 'set-cookie' header value
     * @returns the refreshToken cookie values or error
     */
    CookieParser.prototype.parseRefreshTokenCookie = function (headerValue) {
        if (headerValue === null) {
            return { isValid: false, reason: "MISSING_TOKEN_RESPONSE_COOKIE" };
        }
        var cookiesMap = set_cookie_parser_1.default.parse(set_cookie_parser_1.default.splitCookiesString(headerValue), { map: true });
        var cookie = cookiesMap[this.cookieName];
        if (cookie === undefined) {
            return { isValid: false, reason: "MISSING_TOKEN_RESPONSE_COOKIE" };
        }
        return { isValid: true, payload: CookieParser.cookieToDetails(cookie) };
    };
    CookieParser.cookieToDetails = function (_a) {
        var name = _a.name, value = _a.value, path = _a.path, expires = _a.expires, maxAge = _a.maxAge, domain = _a.domain, secure = _a.secure, httpOnly = _a.httpOnly, sameSite = _a.sameSite;
        return [
            name,
            value,
            __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (path === undefined ? {} : { path: path })), (expires === undefined ? {} : { expires: expires })), (maxAge === undefined ? {} : { maxAge: maxAge * 1000 })), (domain === undefined ? {} : { domain: domain })), (secure === undefined ? {} : { secure: secure })), (httpOnly === undefined ? {} : { httpOnly: httpOnly })), CookieParser.parseSameSite(sameSite)),
        ];
    };
    CookieParser.parseSameSite = function (value) {
        if (value === undefined)
            return {};
        var lowercase = value.toLowerCase();
        return this.isSameSite(lowercase) ? { sameSite: lowercase } : {};
    };
    CookieParser.isSameSite = function (value) {
        return ["strict", "lax", "none"].includes(value);
    };
    return CookieParser;
}());
exports.CookieParser = CookieParser;
